import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";
import { api } from "@/lib/api";
import { formatCHF } from "@/lib/format";
import { validPriceTax } from "@/lib/priceTax";

export default function PublicDeliveryPackCard() {
  const [catalog, setCatalog] = useState({ loading: true, pack: null });

  useEffect(() => {
    let active = true;
    api.get("/subscriptions/packs/catalog", { params: { audience: "private" } })
      .then(({ data }) => {
        const pack = data?.items?.find(item => item.id === "pack_10");
        const tax = pack?.price_tax;
        const valid = pack && Number.isInteger(pack.total_rides) && pack.total_rides > 0
          && Number.isInteger(pack.validity_months) && pack.validity_months > 0
          && validPriceTax(tax) && tax.audience === "private"
          && Number.isFinite(tax.total_chf) && tax.total_chf > 0;
        if (active) setCatalog({ loading: false, pack: valid ? pack : null });
      })
      .catch(() => { if (active) setCatalog({ loading: false, pack: null }); });
    return () => { active = false; };
  }, []);

  const pack = catalog.pack;
  return (
    <section className="bg-dapnow-bg border-y border-dapnow-line" data-testid="private-delivery-pack">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-20">
        <p className="overline text-dapnow-blue">Per le tue consegne ricorrenti</p>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl font-bold tracking-tight">Un pacchetto, senza abbonamento.</h2>
        {catalog.loading ? <p role="status" className="mt-5 text-dapnow-muted">Caricamento del pacchetto…</p> : pack ? (
          <div className="mt-8 card-soft p-6 sm:p-8 grid md:grid-cols-2 gap-8">
            <div>
              <Package className="h-8 w-8 text-dapnow-blue" aria-hidden="true" />
              <h3 className="mt-4 font-display text-2xl font-bold">Pacchetto {pack.total_rides} corse</h3>
              <p className="mt-3 font-display text-4xl font-bold" data-testid="private-pack-price">{formatCHF(pack.price_tax.total_chf)}</p>
              <p className="mt-1 text-sm text-dapnow-muted">IVA inclusa · una tantum · nessun rinnovo automatico</p>
              <p className="mt-4 text-sm">{pack.total_rides} corse, valide {pack.validity_months} mesi dall’attivazione del pacchetto.</p>
              <Link to="/register?audience=private&next=%2Fapp%2Fsubscription" data-testid="private-pack-register" className="btn-primary mt-6">
                Crea account e consulta il pacchetto <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
              <p className="mt-3 text-xs text-dapnow-muted">La registrazione non acquista il pacchetto e non avvia addebiti. Puoi consultarlo nel tuo account prima di confermare qualsiasi acquisto.</p>
            </div>
            <div>
              <h3 className="font-display text-xl font-semibold">Condizioni di utilizzo</h3>
              <ul className="mt-4 space-y-3 text-sm text-dapnow-muted">
                <li>Consegne Standard in Ticino e nei Grigioni italiano, secondo disponibilità della flotta interna.</li>
                <li>Si applicano i limiti di peso e dimensioni della categoria del pacco e gli orari di ritiro del servizio.</li>
                <li>Una consegna idonea utilizza una corsa del pacchetto. Il saldo e la scadenza sono consultabili nel tuo account.</li>
                <li>Express e Van non sono inclusi. Shared è in arrivo e non è prenotabile.</li>
              </ul>
            </div>
          </div>
        ) : <p role="status" className="mt-5 text-dapnow-muted" data-testid="private-pack-unavailable">Il catalogo pacchetti non è disponibile in questo momento. Riprova più tardi per consultare prezzo e condizioni aggiornati.</p>}
      </div>
    </section>
  );
}
